// Rutas operativas sin tenant: /health (probe) y /version (que corre y con
// que contratos).
import { z } from "zod";
import { Integer } from "./common.js";
export const ApiEnvironment = z.enum(["development", "staging", "prod", "test"]).openapi("ApiEnvironment", {
    description: "Entorno en el que corre la API.",
});
export const HealthResponse = z
    .object({
    status: z.enum(["ok"]),
    uptimeSeconds: Integer.min(0),
    version: z.string().min(1).openapi({ description: "Version de la API.", example: "0.0.1" }),
    commitSha: z.string().min(1).optional().openapi({
        description: "Commit desplegado, si el ambiente lo informa.",
    }),
})
    .openapi("HealthResponse", { description: "Probe de salud del proceso." });
export const VersionResponse = z
    .object({
    version: z.string().min(1).openapi({ description: "Version de la API." }),
    contractsVersion: z.string().min(1).openapi({
        description: "CONTRACTS_VERSION con la que se compilo la API: mobile audita paridad contra este valor.",
        example: "0.3.0",
    }),
    environment: ApiEnvironment,
})
    .openapi("VersionResponse", { description: "Version de la API y de los contratos." });
//# sourceMappingURL=health.js.map